
import { Vue } from "vue-class-component";

export default class AttachmentV2 extends Vue {}
